import { render, staticRenderFns } from "./AdminLeadKanbanView.vue?vue&type=template&id=7512b2da"
import script from "./AdminLeadKanbanView.vue?vue&type=script&lang=js"
export * from "./AdminLeadKanbanView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports